export const GMV = "gmv"
export const REFERENCE_EQUITY = "equity"
export const MODEL_COVERAGE = "modelCoverage"
export const POSITIONS = "positions"
export const MAX_CONCENTRATION = "maxConcentration"
export const MIN_CONCENTRATION = "minConcentration"
export const TOP_CONCENTRATION = "topConcentration"
export const POSITIONS_COUNT = "positionsCount"
export const CONCENTRATION = "concentration"
export const LONG = "long"
export const SHORT = "short"
export const OVERWEIGHT = "overweight"
export const UNDERWEIGHT = "underweight"
export const NET = "net"
export const MARKET_CAP = "marketCap"
export const PREDICTED_BETA = "predictedBeta"
export const HISTORICAL_BETA = "historicalBeta"
export const CUSTOM_BETA = "dynamicPredictedBeta"
